module.exports = __webpack_public_path__ + "img/area-chart-light-01.be5a024a.jpg";